import { useState, useEffect, useCallback } from 'react';

export function useLocalStorage<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* storage full */ }
  }, [key, value]);

  const clear = useCallback(() => {
    setValue(initialValue);
    localStorage.removeItem(key);
  }, [initialValue, key]);

  return [value, setValue, clear] as const;
}
